module.exports = __webpack_public_path__ + "img/97.ed39f72a.jpg";